import { useEffect, useState, useRef } from "react";
import * as THREE from "three";
import { SVGLoader } from "three/examples/jsm/loaders/SVGLoader";
import { useContext } from "react";
import StateContext from "../../Context/StateContext";
import {
    calculatePrize,
    // findDiamondIntersection,
    removeAllAlphabets,
    setGlbPosWithBbx,
} from "../commonUtils.js/commonFunc";
import { setTargetToCenterOffTheScreen } from "../commonUtils.js/commonFunc";
import { createSVGTxt, findChainPoints } from "../makerJsUtils/makerJsFunc";
import {
    fitToPlateSize,
    getPointsOfPaths,
    loadSeparateChar,
    removeIndividualChars,
} from "../makerJsUtils/customUtils";
import { restrictSpecialCharacters } from "../alphabetsEditings/restrictSpecialCharacters";
import { useThree } from "react-three-fiber";
import { textTo3D } from "../../Components/ArabicCharPotrace/arabicFont3D";

function MyTextComponent() {
    const globalState = useContext(StateContext);
    const [meshes, setMeshes] = useState([]);

    const { scene } = useThree();
    const pointerDownRef = useRef(null);
    const suppressClickRef = useRef(false);
    useEffect(() => {
        window.scene = scene;
    }, [scene]);

    useEffect(() => {
        const generateTextMesh = async () => {
            try {
                // globalState.dotDiamondRef.current.visible = false;

                removeAllAlphabets(globalState.groupRef.current);
                restrictSpecialCharacters(globalState.text);
                if (globalState.text === "") {
                } else {
                    const allModelData = await createSVGTxt(
                        globalState.text,
                        20,
                        globalState.selectedFont,
                        // globalState.fontNo,
                        globalState.selectedFontLanguage
                    );
                    if (globalState.selectedFontLanguage === "English") {
                        globalState.setGlobalTextModel(
                            allModelData.combinedModelForDotAttachment
                        );
                    } else {
                        globalState.setGlobalTextModel(
                            allModelData.arabicModel
                        );
                    }
                    globalState.setGlobalUserText(allModelData.text);
                    let paths;
                    let loader = new SVGLoader();
                    if (globalState.selectedFontLanguage === "English") {
                        paths = loader.parse(allModelData.svg).paths;
                    } else if (globalState.selectedFontLanguage === "Arabic") {
                        paths = loader.parse(allModelData.svg).paths;
                    }
                    let shapes = paths[0].toShapes(true);

                    const extrudeSettings = {
                        depth: globalState.fontThickness,
                        bevelEnabled: true,
                        bevelSegments: 2,
                        bevelSize: 0.052,
                        bevelThickness: 0.1,
                    };

                    let individualMeshes;
                    let geometry;
                    removeIndividualChars(scene);
                    let svgPathData = allModelData.svgPathData;

                    if (globalState.selectedFontLanguage === "English") {
                        individualMeshes = loadSeparateChar(
                            allModelData.individualCharSVGEng,
                            scene,
                            globalState.globalMaterial.default,
                            extrudeSettings,
                            globalState.selectedFontLanguage,
                            allModelData.textGlyphs
                        );
                        globalState.setIndividualMeshes(individualMeshes);
                        geometry = new THREE.ExtrudeGeometry(
                            shapes,
                            extrudeSettings
                        );
                    } else if (globalState.selectedFontLanguage === "Arabic") {
                        individualMeshes = loadSeparateChar(
                            allModelData.individualCharSVGEng,
                            scene,
                            globalState.globalMaterial.default,
                            extrudeSettings,
                            globalState.selectedFontLanguage
                        );
                        const dummyMesh = new THREE.Mesh();
                        fitToPlateSize(
                            dummyMesh,
                            individualMeshes,
                            shapes,
                            svgPathData,
                            globalState.fontThickness,
                            globalState.selectedFontLanguage
                            //   fontNum
                        );
                        globalState.setIndividualMeshes(individualMeshes);
                        let data = await textTo3D(
                            globalState.text,
                            globalState.selectedFont,
                            extrudeSettings
                        );
                        svgPathData = data.pathSVG;
                        geometry = data.geometry;
                        paths = data.paths;
                        shapes = data.shapes;
                    }
                    let pathPoints = getPointsOfPaths(paths);

                    let chainPoints = [];
                    pathPoints.forEach((path) => {
                        path.forEach((point) => {
                            chainPoints.push([point[0], point[1]]);
                        });
                    });

                    let material = new THREE.MeshStandardMaterial({
                        side: THREE.DoubleSide,
                        depthWrite: false,
                    });
                    const mesh = new THREE.Mesh(geometry, material);

                    let data;
                    if (globalState.selectedFontLanguage === "English") {
                        data = fitToPlateSize(
                            mesh,
                            individualMeshes,
                            shapes,
                            svgPathData,
                            globalState.fontThickness,
                            globalState.currentRawPlateSize,
                            globalState.deviationData
                        );
                    } else if (globalState.selectedFontLanguage === "Arabic") {
                        data = fitToPlateSize(
                            mesh,
                            null,
                            shapes,
                            svgPathData,
                            globalState.fontThickness,
                            globalState.currentRawPlateSize,
                            globalState.deviationData
                            //   fontNum
                        );
                    }

                    globalState.setSvgData(data.svgString);
                    let combinedRatio = data.combinedRatio;
                    globalState.setTextWeight(data.weight);
                    globalState.setPlateSize({
                        width: data.width,
                        height: data.height,
                    });
                    globalState.setPlateArea(data.area);
                    let textPrice = await calculatePrize(
                        data.weight,
                        globalState.goldPrice
                    );
                    globalState.setPrices((prevPrices) => ({
                        ...prevPrices,
                        fontStylePrice: textPrice,
                    }));
                    try {
                        calculatePrize(data.weight, globalState.goldPrice, 0);
                    } catch (error) {
                        console.error(error);
                    }

                    mesh.scale.set(1, 1, 1);
                    globalState.groupRef.current.scale.set(
                        combinedRatio,
                        combinedRatio,
                        1
                    );
                    mesh.rotateX(Math.PI);
                    mesh.name = "3dText";
                    mesh.visible =
                        globalState.selectedFontLanguage === "Arabic";
                    globalState.groupRef.current.add(mesh);
                    globalState.globalMaterial.default.color.set(
                        globalState.color
                    );
                    globalState.globalMaterial.default.roughness =
                        globalState.globalRoughness;
                    globalState.globalMaterial.default.metalness =
                        globalState.globalMetalness;
                    pathPoints.forEach((path) => {
                        path.forEach((point) => {
                            point[0] = point[0] * combinedRatio;
                            point[1] = point[1] * combinedRatio;
                        });
                    });
                    globalState.setGlobalOffsetPathPoints(pathPoints);
                    setGlbPosWithBbx(
                        globalState.groupRef.current,
                        globalState.charmRef.current,
                        combinedRatio
                    );
                    setTargetToCenterOffTheScreen(globalState);
                    const found = [];
                    scene.traverse((child) => {
                        if (child.name === "individualMesh") {
                            found.push(child.clone());
                        }
                    });
                    setMeshes(found);
                    if (chainPoints) {
                        let pointArray = findChainPoints(
                            chainPoints,
                            globalState.chain1Ref.current,
                            globalState.chain2Ref.current,
                            mesh
                        );
                        globalState.setPointArray(pointArray);
                    }

                    mesh.traverse((obj) => {
                        obj.isMesh &&
                            (obj.receiveShadow = obj.castShadow = true);
                        if (obj.isMesh) {
                            obj.material = globalState.globalMaterial.default;
                            globalState.globalMaterial.default.roughness =
                                globalState.globalRoughness;
                        }
                    });
                    if (globalState.groupRef.current) {
                        globalState.groupRef.current.add(mesh);
                    } else {
                        console.error("groupRef.current is undefined.");
                    }
                }
            } catch (error) {
                console.error("Error generating text mesh:", error);
            }
        };
        globalState.controlsRef.current.smoothTime = 0.15;
        globalState.controlsRef.current.draggingSmoothTime = 0.08;
        globalState.controlsRef.current.truckSpeed = 0.00001;
        globalState.controlsRef.current.enablePan = true;
        // globalState.controlsRef.current.minPolarAngle = 0;
        // globalState.controlsRef.current.maxPolarAngle = Math.PI * 0.6;
        globalState.controlsRef.current.maxAzimuthAngle = Infinity;
        globalState.controlsRef.current.minAzimuthAngle = -Infinity;
        globalState.controlsRef.current.enablePan = true;
        let bloomRef = globalState.bloomRef.current;
        bloomRef.luminanceThreshold = 0;
        bloomRef.intensity = 0.1;
        generateTextMesh();
    }, [
        globalState.text,
        globalState.fontThickness,
        globalState.color,
        globalState.currentRawPlateSize,
        globalState.selectedFont,
        globalState.priceDeviation,
        globalState.deviationData,
    ]);
    const findDiamondIntersection = (e) => {
        if (
            globalState.dotDiamondData &&
            !globalState.updateDiamondPos &&
            globalState.addDotDiamond
        ) {
            let diamondSize = parseFloat(globalState.activeDiamondSize); // e.g. 2

            const prev = globalState.diamondPosData || []; // existing array

            // Build a new entry object
            const newEntry = {
                pos: e.point.clone ? e.point.clone() : e.point, // safe clone if it's a THREE.Vector3
                size: 2,
                price: 100,
            };
            // Push it onto the array
            globalState.setDiamondPosData([...prev, newEntry]);
            globalState.setAddDotDiamond(false);
            globalState.setHoveringDiamondDiamondData(null);
            let hoveredDiamond = scene.getObjectByName("hoveredDiamond");
            if (hoveredDiamond) {
                hoveredDiamond.visible = false;
            }
        }
    };

    const updateDiamondPos = (e) => {
        if (globalState.dotDiamondData && globalState.updateDiamondPos) {
            const prev = globalState.diamondPosData || [];
            prev[globalState.diamondPosIndex] = e.point;
            globalState.setDiamondPosData([...prev]);
            globalState.setUpdateDiamondPos(false);
            globalState.controlsRef.current.enabled = true;
        }
    };

    useEffect(() => {
        globalState.setDiamondPosData([]);
    }, [globalState.text, globalState.fontNo, globalState.currentRawPlateSize]);

    return (
        <>
            <group
                ref={globalState.groupRef}
                onPointerDown={(e) => {
                    pointerDownRef.current = { x: e.clientX, y: e.clientY };
                    suppressClickRef.current = false;
                }}
                onPointerUp={(e) => {
                    const down = pointerDownRef.current;
                    const up = { x: e.clientX, y: e.clientY };
                    const threshold = 2;

                    const moved =
                        !down ||
                        Math.abs(down.x - up.x) > threshold ||
                        Math.abs(down.y - up.y) > threshold;

                    if (moved) {
                        suppressClickRef.current = true; // mark to skip click
                    }

                    // Always call update logic
                    updateDiamondPos(e);
                }}
                onClick={(e) => {
                    if (suppressClickRef.current) return; // skip if drag detected
                    findDiamondIntersection(e); // only on pure click
                }}
                onPointerMove={(e) => {
                    if (
                        globalState.addDotDiamond &&
                        globalState.activeTabIndex === 5
                    ) {
                        e.stopPropagation();
                        globalState.setHoveringDiamondDiamondData({
                            pos: e.point.clone ? e.point.clone() : e.point,
                            size: globalState.activeDiamondSize,
                        });
                    }
                }}
                onPointerLeave={(e) => {
                    if (globalState.addDotDiamond) {
                        e.stopPropagation();
                        globalState.setHoveringDiamondDiamondData(null);
                    }
                }}
            />
        </>
    );
}

export default MyTextComponent;
